<template>
  <div>
    <trip-map
      :steps="steps"
      :active-step="activeStep"
      class="map--fullscreen"
    />

    <v-slide-group
      v-model="activeStep"
      mandatory
      center-active
      :show-arrows="$vuetify.breakpoint.smAndUp"
      class="steps-container--horizontal"
    >
      <v-slide-item
        v-for="step in steps.models"
        :key="step.$.id"
        v-slot:default="{ active, toggle }"
        :value="step.$.id"
      >
        <v-card
          class="ma-4"
          width="60vw"
          max-width="250px"
          @click="toggle"
        >
          <v-card-title class="text-truncate">
            {{ step.$.name || step.$.location }}
          </v-card-title>

          <v-card-text>
            <div>
              {{ step.$.startDate | fmtDateInterval(step.$.endDate) }}
            </div>

            <div
              v-if="step.$.location"
              class="text-truncate"
            >
              <v-icon small>
                mdi-map-marker
              </v-icon>
              {{ step.$.location }}
            </div>
          </v-card-text>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<script>
import TripMap from '@/components/TripMap'
import TripMixin from '@/components/TripMixin'

export default {
  name: 'TripMapView',
  components: {
    TripMap
  },
  mixins: [ TripMixin ],
  data () {
    return {
      activeStep: null
    }
  }
}
</script>

<style>
.map--fullscreen {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}

.steps-container--horizontal {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
